import { api } from "./api";

export const stockDetailsItemsFetchApi = (params) => {
  const filter = {
    stock_status: params?.stock_status || "",
    expiry_status: params?.expiry_status || "",
    rx_drugs: params?.rx_drugs || "",
  };

  const encodedFilter = encodeURIComponent(JSON.stringify(filter));

  return api.get(
    `/stock-details/get-items-list?page_no=${params?.page_no || 1}&search=${
      params?.search || ""
    }&filter=${encodedFilter}`
  );
};

export const stockDetailsItemViewApi = (params) => {
  const tab_details = {
    tab_type: params?.tab_type,
    item_id: params?.item_id,
    search: params?.search,
    page_no: params?.page_no,
    sortBy: params?.sortBy,
    sortOrder: params?.sortOrder,
    state: params?.state,
    district: params?.district,
    city: params?.city,
    fromDate: params?.fromDate,
    toDate: params?.toDate,
  };
  console.log(tab_details, "fgdfgdgdgdfgfdgd");
  const encodedFilter = encodeURIComponent(JSON.stringify(tab_details));
  return api.get(`/stock-details/get-items-by-id?tab_details=${encodedFilter}`);
};

export const stockDetailsWarehouseLocationApi = (params) => {
  return api.get(
    `/stock-details/get-warehouse-location?item_id=${params?.item_id}`
  );
};

export const stockDetailsBatchUpdateApi = (params) => {
  return api.post(
    `/stock-details/update-batch-details`,
    JSON.stringify(params)
  );
};
export const stockDetailsBatchDropDownApi = (params) => {
  return api.get(
    `/stock-details/get-batches-dropdown-list?item_id=${params?.item_id}`
  );
};
export const stockDetailsBatchViewApi = (params) => {
  return api.get(
    `/stock-details/update-batch-details-view?item_id=${params?.item_id}&item_batch_number=${params?.item_batch_number}`
  );
};

export const stockAuditCreateApi = (params) => {
  return api.post(`/stock-audit/create`, JSON.stringify(params));
};

export const stockAuditTableApi = (params) => {
  const { pageNumber, pageSize, filterData = {} } = params;

  const {
    sort_by,
    sort_order,
    status,
    audit_type,
    selectColumn,
    inputValue,
    from,
    to,
  } = filterData;

  const searchParams = new URLSearchParams({
    pageNumber,
    pageSize,
    sortBy: sort_by,
    sortOrder: sort_order,
    status,
    audit_type,
  });

  if (inputValue) {
    searchParams.append("searchColumn", selectColumn);
    searchParams.append("searchValue", inputValue);
  }

  if (from) searchParams.append("from_date", from);
  if (to) searchParams.append("to_date", to);

  return api.get(`/stock-audit/list?${searchParams.toString()}`);
};

export const stockAuditViewApi = (params) => {
  return api.get(
    `/stock-audit/get-stock-audit-items-by-id?sat_id=${params?.sat_id}`,
    JSON.stringify(params)
  );
};
export const stockAuditEditApi = (params) => {
  return api.post(`/stock-audit/update-draft-order`, JSON.stringify(params));
};
export const stockAuditUploadCsvApi = (params) => {
  return api.post(`/stock-audit/upload-csv`, JSON.stringify(params));
};
// TODO: placeholder endpoint — replace `/stock-audit/delete` with the real delete/void route once available
export const stockAuditDeleteApi = (params) => {
  return api.post(`/stock-audit/void`, JSON.stringify(params));
};
export const stockAuditLoadFiltersApi = (params) => {
  return api.get(
    `/stock-audit/get-item-load-with-filters?manufacturer=${params?.manufacturer}&item_type=${params?.item_type}&bin_location=${params?.bin_location}&item_group=${params?.item_group}&item_category=${params?.item_category}&initials=${params?.initials}`
  );
};
